import {
    mapGetters,
    mapActions,
    mapMutations
  } from 'vuex'
  
  import * as carManagerStore from '@/store/carManager'
  
  export {
    carManagerStore
  }
  
  /**
     * Search store.
     *
     * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
     */
  export const createCarManagerMixin = (without = []) => {
    const actions = !without.includes('actions') ? mapActions(carManagerStore.moduleName, Object.keys(carManagerStore.actionTypes)) : {}
    const getters = !without.includes('getters') ? mapGetters(carManagerStore.moduleName, Object.keys(carManagerStore.getterTypes)) : {}
    const mutations = !without.includes('mutations') ? mapMutations(carManagerStore.moduleName, Object.keys(carManagerStore.mutationTypes)) : {}
  
    return {
      methods: {
        ...actions,
        ...mutations
      },
      computed: {
        ...getters
      }
    }
  }
  